import { RequestError } from './types';
import { createAction } from 'redux-actions';
import { actionTypePrefix } from './constants';
import { PapiUser } from '@wix/da-papi-types';

const clickWatchAction = createAction(
  `${actionTypePrefix}/CLICK_WATCH`,
  (
    user: PapiUser,
    isWatching: boolean,
    onToggleWatchSuccess: (isWatching: boolean) => void | undefined
  ) => ({
    user,
    isWatching,
    onToggleWatchSuccess,
  })
);

// TS shenanigans...
export const clickWatch = clickWatchAction as (
  user: PapiUser,
  isWatching: boolean,
  onToggleWatchSuccess?: (isWatching: boolean) => void
) => ReturnType<typeof clickWatchAction>;

export const requestSuccess = createAction(
  `${actionTypePrefix}/REQUEST_SUCCESS`,
  (username: string, isWatching: boolean) => ({
    username,
    isWatching,
  })
);

export const requestFailure = createAction(
  `${actionTypePrefix}/REQUEST_FAILURE`,
  (username: string, error: RequestError) => ({
    username,
    error,
  })
);

export const setWatchingState = createAction(
  `${actionTypePrefix}/SET_WATCHING_STATE`,
  (username: string, isWatching: boolean) => ({ username, isWatching })
);
